import React from 'react'
import {AvatarContainer, CardContainer, CardSection, KpiDescribeSection} from "./CardProductInsight.style";
import {Avatar, Tooltip} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {AnalisisHorarioContainer, DayContainer, DayName, DayValue} from "../../Clientes/CardCliente/CardCliente.style";
import {Brightness1, Brightness4, Brightness6, Brightness7, NightsStay} from "@material-ui/icons";
import {amber, blueGrey, grey, teal, yellow} from "@material-ui/core/colors";
import {Button} from "@material-ui/core/";


export const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
}))(Tooltip);

const CardProductInsight = ({ product, formatCurrency, launchProductModal }) => {

    const diasEntrega = (product?.DiasPreferenciaEntrega || "").split(",")
    const preferenceColorLevel = [teal[900], teal[700], teal[500], teal[400], teal[300], teal[200], teal[100]]

    const parseDayName = { lun: "lunes", mar: "martes", mie: "miercoles", jue: "jueves", vie: "viernes", sab: "sabado", dom: "domingo"}
    const safeDecode = (value) => {
        if (!value) return "Sin datos";
        try {
            return decodeURIComponent(value);
        } catch (error) {
            return value;
        }
    }
    const jornadaPreferencia = product?.JornadaPreferenciaEntrega || "Sin datos";
    const diaPreferencia = parseDayName[product?.DiaPreferenciaEntrega] || "sin datos";
    const jornadaLabel = jornadaPreferencia !== "Sin datos" ? jornadaPreferencia.toLowerCase() : "sin datos";


    return (
        <CardContainer>
            <CardSection>
                <AvatarContainer>
                    <Avatar src={product.ImagenXS}/>
                </AvatarContainer>
                <p>{safeDecode(product?.Nombre)}</p>
            </CardSection>
            <CardSection>
                <LightTooltip title={`Los clientes prefieren este producto habitualmente los días ${diaPreferencia} y frecuentemente en ${jornadaPreferencia === "Mediodía" ? "el" : "la"} ${jornadaLabel}`}>
                    <AnalisisHorarioContainer>
                        <DayContainer style={{marginRight: 8}}>
                            <DayValue color={"none"} >
                                {
                                    jornadaPreferencia === "Madrugada" && <NightsStay style={{color: blueGrey[700]}}/>
                                }
                                {
                                    jornadaPreferencia === "Mañana" && <Brightness6 style={{color: amber[300]}}/>
                                }
                                {
                                    jornadaPreferencia === "Mediodía" && <Brightness7 style={{color: yellow[600]}}/>
                                }
                                {
                                    jornadaPreferencia === "Tarde" && <Brightness4 style={{color: yellow[800]}}/>
                                }
                                {
                                    jornadaPreferencia === "Noche" && <Brightness1 style={{color: grey[700]}}/>
                                }
                            </DayValue>
                            <DayName>{jornadaPreferencia}</DayName>
                        </DayContainer>
                        <DayContainer>
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("lun")]}/>
                            <DayName>L</DayName>
                        </DayContainer>
                        <DayContainer>
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("mar")]}/>
                            <DayName>M</DayName>
                        </DayContainer>
                        <DayContainer >
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("mie")]}/>
                            <DayName>M</DayName>
                        </DayContainer>
                        <DayContainer >
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("jue")]}/>
                            <DayName>J</DayName>
                        </DayContainer>
                        <DayContainer >
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("vie")]}/>
                            <DayName>V</DayName>
                        </DayContainer>
                        <DayContainer color={preferenceColorLevel[diasEntrega.indexOf("sab")]}>
                            <DayValue />
                            <DayName>S</DayName>
                        </DayContainer>
                        <DayContainer >
                            <DayValue color={preferenceColorLevel[diasEntrega.indexOf("dom")]}/>
                            <DayName>D</DayName>
                        </DayContainer>
                    </AnalisisHorarioContainer>
                </LightTooltip>
            </CardSection>
            <CardSection>
                <KpiDescribeSection>
                    <LightTooltip title={"Compra histórica del producto, desde la primera venta hasta el día actual"}>
                        <p><strong>HIST:</strong> {formatCurrency(product?.VentaHistorica || 0)} ({formatCurrency(product?.CantidadHistorico || 0, true)} items en {formatCurrency(product?.PedidosHistorico || 0, true)} pedidos)</p>
                    </LightTooltip>
                    <LightTooltip title={"Compra de los úlrimos 365 días"}>
                        <p><strong>LY:</strong> {formatCurrency(product?.VentaLY || 0)} ({formatCurrency(product?.CantidadLY || 0, true)} items en {formatCurrency(product?.PedidosLY || 0, true)} pedidos)</p>
                    </LightTooltip>
                    <LightTooltip title={"Compra desde el primer día del mes hasta el día actual"}>
                        <p><strong>MTD:</strong> {formatCurrency(product?.VentaMTD || 0)} ({formatCurrency(product?.CantidadMTD || 0, true)} items en {formatCurrency(product?.PedidosMTD || 0, true)} pedidos)</p>
                    </LightTooltip>
                    <LightTooltip title={"Compra desde el primer día del año hasta el día actual"}>
                        <p><strong>YTD:</strong> {formatCurrency(product?.VentaYTD || 0)} ({formatCurrency(product?.CantidadYTD || 0, true)} items en {formatCurrency(product?.PedidosYTD || 0, true)} pedidos)</p>
                    </LightTooltip>
                </KpiDescribeSection>
            </CardSection>
            <CardSection style={{marginTop: 20}}>
                <Button variant={"contained"} size={"small"} onClick={() => launchProductModal(product)}>Más información</Button>
            </CardSection>
        </CardContainer>
    )
}

export default CardProductInsight